import React, { useState } from 'react';
import './OrderPipeline.css';

const OrderPipeline = () => {
  const [currentStep, setCurrentStep] = useState(5); // Default at 'Warehouse / Pickup'

  const pipelineStages = [
    {
      id: 1,
      name: 'Order Placed',
      short: 'Placed',
      icon: '📝',
      desc: 'Buyer submits structured wholesale specifications and sets settlement preference.',
    },
    {
      id: 2,
      name: 'Seller Accepted',
      short: 'Accepted',
      icon: '🤝',
      desc: 'Manufacturer locks bullion pricing, validates raw material allocation, and acknowledges delivery SLA.',
    },
    {
      id: 3,
      name: 'Preparation',
      short: 'Karigar Staging',
      icon: '⚒️',
      desc: 'Jewellery fabrication, stone setting, and preliminary weighing at the seller atelier.',
    },
    {
      id: 4,
      name: 'Assorted',
      short: 'Assayed',
      icon: '🔬',
      desc: 'BIS Hallmarking HUID laser inscription and exact gemstone tare deductions verified.',
    },
    {
      id: 5,
      name: 'Ready',
      short: 'Vault Ready',
      icon: '🛡️',
      desc: 'Barcoded tamper-evident security packaging sealed with digital weighment certificate.',
    },
    {
      id: 6,
      name: 'Warehouse / Pickup',
      short: 'In Custody',
      icon: '🏢',
      desc: 'JMI logistics operator performs dual-custody physical receipt and weight audit at regional hub.',
    },
    {
      id: 7,
      name: 'Dispatched',
      short: 'Insured Transit',
      icon: '🚚',
      desc: 'Armed courier / secured carrier transport under real-time telemetry and 100% transit insurance.',
    },
    {
      id: 8,
      name: 'Delivered',
      short: 'Completed',
      icon: '✅',
      desc: 'Buyer verifies tamper seal, conducts retail counter weighment, and confirms OTP release.',
    },
  ];

  return (
    <div className="order-pipeline-widget">
      <div className="pipeline-header">
        <div className="pipeline-title-box">
          <span className="live-status-pill">LIVE PIPELINE SIMULATOR</span>
          <h4 className="pipeline-title">Order Fulfilment Custody Pipeline</h4>
        </div>
        <div className="pipeline-meta">
          <span className="order-id-label">Consignment: #JMI-9482-DEL</span>
        </div>
      </div>

      {/* Visual Stepper */}
      <div className="pipeline-stepper">
        {pipelineStages.map((stage) => {
          const isCompleted = stage.id < currentStep;
          const isCurrent = stage.id === currentStep;

          return (
            <div 
              key={stage.id} 
              className={`pipeline-node ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''}`}
              onClick={() => setCurrentStep(stage.id)}
            >
              <div className="node-bubble">
                <span className="node-icon-char">
                  {isCompleted ? '✓' : stage.icon}
                </span>
              </div>
              <span className="node-name-label">{stage.short}</span>
            </div>
          );
        })}
      </div>

      {/* Active Stage Details Card */}
      <div className="active-stage-card">
        <div className="stage-card-top">
          <div className="stage-indicator">
            <span className="stage-num">Stage 0{currentStep} of 08</span>
            <h5 className="stage-name">{pipelineStages[currentStep - 1].name}</h5>
          </div>
          <span className="stage-status-badge">
            {currentStep === 8 ? 'Transaction Completed' : 'In Progress (Operator Verified)'}
          </span>
        </div>
        <p className="stage-detail-text">
          {pipelineStages[currentStep - 1].desc}
        </p>
      </div>
    </div>
  );
};

export default OrderPipeline;
